module.exports = __webpack_public_path__ + "static/img/10.f46ade2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/10.png
// module id = G5D8
// module chunks = 0